var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounDock1839587(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-25.6 -51.2 563.2 691.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M392.283,382.102c-1.799,0.078-3.709,0.12-5.746,0.12c-31.676,0-32.615-10.058-62.476-10.651  c-0.908-0.019-1.839-0.029-2.802-0.029c-14.015,0-22.008,1.971-29.154,4.218c-9.496,2.987-17.495,6.463-36.115,6.463  c-15.966,0-24.12-2.557-32.107-5.168c-8.131-2.659-16.11-5.366-31.957-5.5c-0.405-0.004-0.792-0.013-1.207-0.013  c-32.634,0-32.634,10.681-65.268,10.681c-32.633,0-32.633-10.681-65.267-10.681v79.775h391.629v-79.775  c-12.992,0-20.809,1.693-27.574,3.73C415.068,378.033,407.831,381.428,392.283,382.102z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M88.993,276.543v24.961c0,2.09,1.694,3.783,3.784,3.783h99.149v52.025c15.313,0.123,24.369,2.529,31.957,4.951v-56.977  h68.222v55.758c7.041-2.018,15.745-3.745,29.154-3.745c0.961,0,1.887,0.013,2.802,0.03v-52.043h68.222v62.561  c10.805-0.51,16.799-2.462,23.57-4.678c2.613-0.855,5.336-1.745,8.387-2.566v-55.316h27.574v-32.528H92.777  C90.688,272.759,88.993,274.453,88.993,276.543z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounDock1839587);
export default __webpack_public_path__ + "static/media/noun-dock-1839587.1eb8b1a1c165c80c97b14ee5c7ec5284.svg";
export { ForwardRef as ReactComponent };